module.exports = __webpack_public_path__ + "img/Memberkit-4-en.8683eee5.png";